import {Injectable} from "@angular/core";
import {ClearingCrudComponent} from "../../../crystal-clear/support/clearing-crud/clearing-crud.component";
import {Clearing} from "../../../model/clearing/clearing";
import {resolveFieldTypes} from "../../../utils/object-reflection";
import {TableColumnUtils} from "../../../utils/table-column-utils";
import {AccountDefinition} from "../../../model/customer/account-definition";
import {TableColumnConfig} from "../../../model/api/table-column-config";
import {Trade} from "../../../model/clearing/trade";
import CallPut = Trade.CallPut;

@Injectable({providedIn: 'root'})
export class SupportClearingTableConfigService {

  private readonly fieldTypes = resolveFieldTypes<Clearing>({
    // side: 'enum',
    state: 'enum',
    // callPut: 'enum',
    // agressorInd: 'enum',

    // executionDate: 'date',
    // businessDate: 'date',
    clearingDate: 'date',

    creationDate: 'datetime',
    modificationDate: 'datetime',

    // clearings: 'array',
    // clearingInfo: 'object',

    // finalPrice: 'boolean',
    // exchangeMatched: 'boolean'
  });

  loadConfig(component: ClearingCrudComponent) {

    const tableConfig: TableColumnConfig[] = (Object.keys(component.newRecord ?? {}) as Array<keyof Clearing>)
      .filter(field => !this.isExcluded(field))
      .map(field => {
        const type = this.fieldTypes[field];

        const column = TableColumnUtils.buildColumn<Clearing>(
          field,
          type,
          this.clearingOverrides(field, type)
        );

        ClearingTableFilters.apply(column, field);
        return column;
      });

    tableConfig.forEach(columnConfig => {
      if (columnConfig.field === 'id'
        || columnConfig.field === 'parentId'
        || columnConfig.field === 'orderId'
        || columnConfig.field === 'tradeId') {
        columnConfig.width = 250;
      }
    })

    return tableConfig;
  }

  private clearingOverrides(field: keyof Clearing, type: any) {
    if (field === 'account') {
      return {
        mapId: (record: Clearing) => record.account?.name
      };
    }

    if (type === 'boolean') {
      return {
        icon: TableColumnUtils.booleanIcon<Clearing>(field),
        mapId: TableColumnUtils.booleanMapId()
      };
    }

    return {};
  }

  private isExcluded(field: keyof Clearing): boolean {
    return [
      'clearings',
      'clearingInfo'
    ].includes(field as string);
  }
}


export class ClearingTableFilters {

  static apply(column: TableColumnConfig, field: keyof Clearing): void {

    const f = field.toLowerCase();

    const filterType =
      ['businessdate', 'clearingdate', 'creationdate', 'executiondate'].includes(f) ? 'date' :
        ['volume', 'price', 'avgprice', 'avgrndprice', 'avgpriceresidual', 'overrideavgprice', 'strike', 'strategymissing'].includes(f) ? 'numeric' :
          ['side', 'openclose'].includes(f) ? undefined :
            'text';

    column.filterConfig = {
      type: filterType,
      matchMode: filterType === 'text' ? 'contains' : undefined,
      values: undefined
    };

    /*if (field === 'side') {
      column.filterConfig.values = Object.values(Trade.Side);
      column.filterConfig.matchMode = 'equals';
    } else*/
    if (field === 'openClose') {
      column.filterConfig.values = Object.values(AccountDefinition.OpenClose);
      column.filterConfig.matchMode = 'in';
      // } else if (field === 'callPut') {
      //   column.filterConfig.values = Object.values(CallPut);
      //   column.filterConfig.matchMode = 'in';
    }
  }
}
